export function newRequirementId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return `req_${crypto.randomUUID().replace(/-/g, "").slice(0, 12)}`;
  }
  return `req_${Math.random().toString(16).slice(2, 14)}`;
}

export function requirementItemsFromText(text) {
  return String(text || "")
    .split(/\r?\n/)
    .map((line) => line.replace(/^\s*[-*•]\s*/, "").trim())
    .filter(Boolean)
    .map((line) => ({ id: newRequirementId(), text: line }));
}

export function requirementItemsFromOpening(opening) {
  const raw = Array.isArray(opening?.requirement_items)
    ? opening.requirement_items
    : [];
  const items = raw
    .map((item) => ({
      id: item?.id || newRequirementId(),
      text: String(item?.text || "").trim(),
    }))
    .filter((item) => item.text);
  if (items.length) return items;
  return requirementItemsFromText(opening?.requirements);
}

export function requirementChecksFromSource(opening, existing) {
  if (Array.isArray(existing) && existing.length) {
    return existing
      .map((item) => ({
        id: item?.id || newRequirementId(),
        text: String(item?.text || "").trim(),
        checked: !!item?.checked,
      }))
      .filter((item) => item.text);
  }
  return requirementItemsFromOpening(opening).map((item) => ({
    ...item,
    checked: false,
  }));
}
